import React from "react";
import { useTranslation } from "react-i18next";
import { useZoneRemoval } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import styles from "./styles.scss";

function ZoneRemoval(props: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeZone } = useZoneRemoval(props.zone);

  return (
    <Modal
      header={t("zoneRemoval.title")}
      headerClassName={styles.header}
      close={props.cancel}
    >
      <div className={styles.main}>
        <p className={styles.message}>
          {t("zoneRemoval.message")}{" "}
          <span className={styles.name}>{props.zone.name}</span>{" "}
          {t("zoneRemoval.message2")}
        </p>
        <div className={styles.buttons}>
          <Button type="cancel" press={props.cancel}>
            {t("zoneRemoval.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            isDisabled={isRequestPending}
            press={() => removeZone(props.zone)}
          >
            {t("zoneRemoval.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ZoneRemoval };
